import { IOperatorInstructionModel } from "../../../typewriterModels/IOperatorInstructionModel";
import { ISortBoxModel } from "../../sortbox/ISortBoxModel";
import { IPayloadWrapper } from "../types/PayloadWrapper";
import { ActionStates } from "../../rxMode/ActionStates";
import { IRxComment } from "../../rxMode/IRxComment";
import { IRxBoxAppState } from "../../rxMode/IRxBoxAppState";
import { IRxAssistantOperator } from "../../rxMode/IRxAssistantOperator";
import { ISingleSortBoxItemModel, ISortBoxItemModel } from "../../SortBoxItem/ISortBoxItemModel";
import { LimaOperatorTask } from "../../../typewriterModels/CommonEnum";
import {
  IOrderInfo,
  IRxSortBoxItemUpdate,
  IRXOperatorInfoModel,
  IBoxCancellationRequest,
  IPurgeRequest,
  IBoxNotification,
} from "../../rxAutoMessages/rxAutoMessages";

export const POLL_FOR_RX_ORDER = "automatpacken/rxBox/POLL_RX_ORDER";
export const FETCH_RX_BOX_MODEL = "automatpacken/rxBox/FETCH_RX_BOX_MODEL";
export const SET_RX_BOX_MODEL = "automatpacken/rxBox/SET_RX_BOX_MODEL";
export const SET_RX_INSTRUCTION = "automatpacken/rxBox/SET_RX_INSTRUCTION";
export const SET_RX_CRATE_ID = "automatpacken/rxBox/SET_RX_CRATE_ID";
export const HIDE_RX_COMMENT = "automatpacken/rxBox/HIDE_RX_COMMENT";
export const SET_RX_COMMENTS = "automatpacken/rxBox/SET_RX_COMMENTS";
export const CLEAR_RX_ORDER = "automatpacken/rxBox/CLEAR_RX_ORDER";
export const SET_RX_ORDER_SKU = "automatpacken/rxBox/SET_RX_ORDER_SKU";
export const SET_RX_ORDER_NUMBER = "automatpacken/rxBox/SET_RX_ORDER_NUMBER";
export const SET_RX_MODE_ACTION_STATE = "automatpacken/rxBox/SET_RX_MODE_ACTION_STATE";
export const CLEAR_RX_MODE_STATE = "automatpacken/rxBox/CLEAR_RX_MODE_STATE";
export const FETCH_ORDER_COMMENTS_FOR_RX_ORDER =
  "automatpacken/rxBox/FETCH_ORDER_COMMENTS_FOR_RX_ORDER";
export const SET_RX_SORT_ID = "automatpacken/rxBox/SET_RX_SORT_ID";
export const SET_RX_SORTBOX_ID = "automatpacken/rxBox/SET_RX_SORTBOX_ID";
export const POLL_FOR_RX_NEXT_SORTBOX = "automatpacken/rxBox/POLL_FOR_RX_NEXT_SORTBOX";
export const SET_RX_NEXT_CART_SHELF = "automatpacken/rxBox/SET_RX_NEXT_CART_SHELF";
export const SET_RX_FULL_CART_NUMBER = "automatpacken/rxBox/SET_RX_FULL_CART_NUMBER";
export const CANCEL_RX_SORT_BOX = "automatpacken/rxBox/CANCEL_RX_SORT_BOX";
export const SET_RX_VERIFY_OPERATOR = "automatpacken/rxBox/SET_RX_VERIFY_OPERATOR";
export const SET_RX_POLL_FOR_ORDER_INTERVAL_ID =
  "automatpacken/rxBox/SET_RX_POLL_FOR_ORDER_INTERVAL_ID";
export const SET_RX_POLL_FOR_NEXT_SORT_BOX_INTERVAL_ID =
  "automatpacken/rxBox/SET_RX_POLL_FOR_NEXT_SORT_BOX_INTERVAL_ID";
export const SET_RX_ASSISTING_OPERATOR = "automatpacken/rxBox/SET_RX_ASSISTING_OPERATOR";
export const SET_RX_ASSISTING_OPERATOR_STATE =
  "automatpacken/rxBox/SET_RX_ASSISTING_OPERATOR_STATE";
export const CLEAR_RX_ASSISTING_OPERATOR = "automatpacken/rxBox/CLEAR_RX_ASSISTING_OPERATOR";
export const GET_RX_ASSISTING_OPERATOR = "automatpacken/rxBox/GET_RX_ASSISTING_OPERATOR";
export const SET_RX_WARNING_MESSAGES = "automatpacken/rxBox/SET_RX_WARNING_MESSAGES";
export const FETCH_WARNING_MESSAGES_FOR_RX_ORDER =
  "automatpacken/rxBox/FETCH_WARNING_MESSAGES_FOR_RX_ORDER";
export const SET_SHOW_SINGLE_ITEM_LIST = "automatpacken/rxBox/SET_SHOW_SINGLE_ITEM_LIST";
export const FETCH_RX_SINGLE_ITEMS = "automatpacken/rxBox/FETCH_RX_SINGLE_ITEMS";
export const SET_RX_SINGLE_ITEMS = "automatpacken/rxBox/SET_RX_SINGLE_ITEMS";
export const FETCH_RX_OPERATOR_INSTRUCTION =
  "automatpacken/rxBox/FETCH_RX_OPERATOR_INSTRUCTION_FOR_WORKSTATION";
export const SET_RX_PREVIOUS_INSTRUCTION = "automatpacken/rxBox/SET_RX_PREVIOUS_INSTRUCTION";
export const CLEAR_OPERATOR_INSTRUCTION = "automatpacken/rxBox/CLEAR_OPERATOR_INSTRUCTION";
export const SET_CANCELLED_RX_ORDER_SKU = "automatpacken/rxBox/SET_CANCELLED_RX_ORDER_SKU";
export const SET_RX_WEIGHT_ERROR = "automatpacken/rxBox/SET_RX_WEIGHT_ERROR";
export const SET_INPUT_TASK = "automatpacken/rxBox/SET_INPUT_TASK";
export const SET_SINGLE_TRANSPORTCART = "automatpacken/rxBox/SET_SINGLE_TRANSPORTCART";
export const SET_NORMAL_TRANSPORTCART = "automatpacken/rxBox/SET_NORMAL_TRANSPORTCART";
export const SET_TRANSPORTCART_REGISTRATION_STARTED =
  "automatpacken/rxBox/SET_TRANSPORTCART_REGISTRATION_STARTED";
export const SET_LAST_CARTSHELF = "automatpacken/rxBox/SET_LAST_CARTSHELF";
export const SET_HAS_SHOWN_RX_CHECK_SUBSIDY_INTRUCTION =
  "automatpacken/rxBox/SET_HAS_SHOWN_RX_CHECK_SUBSIDY_INTRUCTION";
export const SET_MISSING_SORTBOX_ITEM = "automatpacken/rxBox/SET_MISSING_SORTBOX_ITEM";
export const SET_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM =
  "automatpacken/rxBox/SET_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM";
export const SET_SIGNALR_CONNECTION_STATUS = "automatpacken/rxBox/SET_SIGNALR_CONNECTION_STATUS";
export const SIGNALR_MESSAGE_RECEIVED = "automatpacken/rxBox/SIGNALR_MESSAGE_RECEIVED";
export const SET_SORT_BOX_ITEM_QUANTITY = "automatpacken/rxBox/SET_SORT_BOX_ITEM_QUANTITY";
export const SET_SORT_BOX_FINISHED_RX_AUTO = "automatpacken/rxBox/SET_SORT_BOX_FINISHED_RX_AUTO";
export const SEND_SCANNED_IPACK_BOX_BARCODE = "automatpacken/rxBox/SEND_SCANNED_IPACK_BOX_BARCODE";
export const SIGNALR_START = "START_SIGNALR";
export const SIGNALR_SEND_SCANNED_BOX = "automatpacken/rxBox/SIGNALR_SEND_SCANNED_BOX";
export const SET_ORDER_INFO = "automatpacken/rxBox/SET_ORDER_INFO";
export const UPDATE_ORDER_INFO = "automatpacken/rxBox/UPDATE_ORDER_INFO";
export const SCAN_IPACK_BOX_BARCODE = "automatpacken/rxBox/SCAN_IPACK_BOX_BARCODE";
export const FETCH_FULL_ORDER = "automatpacken/rxBox/FETCH_FULL_ORDER";
export const SEND_LOGIN_INFO = "automatpacken/rxBox/SEND_LOGIN_INFO";
export const SET_STATION_PAUSED = "automatpacken/rxBox/SET_STATION_PAUSED";
export const SET_CURRENT_BOX_SNOOZED = "automatpacken/rxBox/SET_CURRENT_BOX_SNOOZED";
export const SEND_BOX_CANCELLATION = "automatpacken/rxBox/SEND_BOX_CANCELLATION";
export const SET_BOX_CANCELLED = "automatpacken/rxBox/SET_BOX_CANCELLED";
export const SET_RX_CANCEL_OR_FINISH_MODAL_STATUS =
  "automatpacken/rxBox/SET_RX_CANCEL_OR_FINISH_MODAL_STATUS";
export const SET_RX_LAST_ACTION_TIMESTAMP = "automatpacken/rxBox/SET_RX_LAST_ACTION_TIMESTAMP";
export const SET_MAXX_MODE = "automatpacken/rxBox/SET_MAXX_MODE";
export const SEND_MAXX_ORDER_FINISHED = "automatpacken/rxBox/SEND_MAXX_ORDER_FINISHED";
export const SET_LOOP_TEAMLEADER = "automatpacken/rxBox/SET_LOOP_TEAMLEADER";
export const SET_RX_CANCELLATION_WITH_REASON_MODAL_STATUS =
  "automatpacken/rxBox/SET_RX_CANCELLATION_WITH_REASON_MODAL_STATUS";
export const SET_RX_CANCELLATION_NON_RX_OR_DONE_MODAL_STATUS =
  "automatpacken/rxBox/SET_RX_CANCELLATION_NON_RX_OR_DONE_MODAL_STATUS";
export const GET_TEAMLEADER_AVAILABILITY = "automatpacken/rxBox/GET_TEAMLEADER_AVAILABILITY";
export const SET_TEAMLEADER_AVAILABILITY = "automatpacken/rxBox/SET_TEAMLEADER_AVAILABILITY";
export const SET_CANCELLATION_REASON_MESSAGE_SHOWN =
  "automatpacken/rxBox/SET_CANCELLATION_REASON_MODAL_SHOWN";
export const SET_FLUSH_QUEUE_MODAL_STATUS = "automatpacken/rxBox/SET_FLUSH_QUEUE_MODAL_STATUS";
export const SEND_FLUSH_QUEUE_REQUEST = "automatpacken/rxBox/SEND_FLUSH_QUEUE_REQUEST";
export const SET_INSTRUCTION_MESSAGE = "automatpacken/rxBox/SET_INSTRUCTION_MESSAGE";
export const SET_SKU_PUTAWAY_BOXID = "automatpacken/rxBox/SET_SKU_PUTAWAY_BOXID";
export const SET_SKU_PUTAWAY_BOX_ITEM = "automatpacken/rxBox/SET_SKU_PUTAWAY_BOX_ITEM";
export const SET_SKU_PUTAWAY_BIN_SHELFNUMBER = "automatpacken/rxBox/SET_SKU_PUTAWAY_SHELFNUMBER";
export const PERFORM_SKU_PUTAWAY_MISSING_QUANTITY = "automatpacken/rxBox/PERFORM_SKU_PUTAWAY_MISSING_QUANTITY";
export const SKU_PUTAWAY_ERROR_MESSAGE = "automatpacken/rxBox/SKU_PUTAWAY_ERROR_MESSAGE";
export const WAITING_FOR_EJECT_BOX = "automatpacken/rxBox/WAITING_FOR_EJECT_BOX";
export const SET_RX_AUTO_ORDER_DONE = "automatpacken/rxBox/SET_RX_AUTO_ORDER_DONE";
export const BOX_NOTIFICATION = "automatpacken/rxBox/BOX_NOTIFICATION";
export const SET_WAREHOUSE_ALARM = "automatpacken/rxBox/SET_WAREHOUSE_ALARM";

export const setRxAutoOrderDone = () => {
  return {
    type: SET_RX_AUTO_ORDER_DONE,
  };
};


export const setWaitingForEjectBox = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: WAITING_FOR_EJECT_BOX,
    payload,
  };
};

export const boxNotification = (payload: IBoxNotification) => {
  return {
    type: BOX_NOTIFICATION,
    payload,
  }
}

export const setSkuPutawayErrorMessage = (payload: IPayloadWrapper<string | null>) => {
  return {
    type: SKU_PUTAWAY_ERROR_MESSAGE,
    payload,
  };
};

export const perfromSkuPutawayMissingQuantity = (payload: IPayloadWrapper<number>) => {
  return {
    type: PERFORM_SKU_PUTAWAY_MISSING_QUANTITY,
    payload,
  };
};

export const setSkuPutawayBinShelfNumber = (payload: IPayloadWrapper<string| null>) => {
  return {
    type: SET_SKU_PUTAWAY_BIN_SHELFNUMBER,
    payload,
  };
};

export const setSkuPutawayBoxItem = (payload: IPayloadWrapper<ISortBoxItemModel| null>) => {
  return {
    type: SET_SKU_PUTAWAY_BOX_ITEM,
    payload,
  };
};


export const setSkuPutawayBoxID = (payload: IPayloadWrapper<number| null>) => {
  return {
    type: SET_SKU_PUTAWAY_BOXID,
    payload,
  };
};


export const sendFlushQueueRequest = (payload: IPurgeRequest) => {
    return {
        type: SEND_FLUSH_QUEUE_REQUEST,
        payload,
    };
};

export const setFlushQueueModalStatus = (payload: IPayloadWrapper<boolean>) => {
    return {
        type: SET_FLUSH_QUEUE_MODAL_STATUS,
        payload,
    };
};

export const setRxInstructionMessage = (payload: IPayloadWrapper<string | null>) => {
  return {
      type: SET_INSTRUCTION_MESSAGE,
      payload,
  };
};

export const setCancelleationReasonMessageShown = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_CANCELLATION_REASON_MESSAGE_SHOWN,
    payload,
  };
};

export const getTeamleaderAvailability = () => {
  return {
    type: GET_TEAMLEADER_AVAILABILITY,
  };
};

export const setTeamleaderAvailability = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_TEAMLEADER_AVAILABILITY,
    payload,
  };
};

export const setLoopTeamleader = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_LOOP_TEAMLEADER,
    payload,
  };
};

export const sendMaxxOrderFinished = () => {
  return {
    type: SEND_MAXX_ORDER_FINISHED,
  };
};

export const setMaxxMode = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_MAXX_MODE,
    payload,
  };
};

export const setBoxCancelled = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_BOX_CANCELLED,
    payload,
  };
};

export const setCurrentBoxSnoozed = () => {
  return {
    type: SET_CURRENT_BOX_SNOOZED,
  };
};

export const sendBoxCancellation = (payload: IBoxCancellationRequest) => {
  return {
    type: SEND_BOX_CANCELLATION,
    payload,
  };
};

export const setStationPaused = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_STATION_PAUSED,
    payload,
  };
};

export const updateSortBoxItemQuantity = (payload: IRxSortBoxItemUpdate) => {
  return {
    type: SET_SORT_BOX_ITEM_QUANTITY,
    payload,
  };
};

export const sendScannedIPackBoxBarcode = (payload: IPayloadWrapper<string>) => {
  return {
    type: SEND_SCANNED_IPACK_BOX_BARCODE,
    payload,
  };
};

export const sendLoginInfo = (payload: IRXOperatorInfoModel) => {
  return {
    type: SEND_LOGIN_INFO,
    payload,
  };
};

export const signaRMessageReceived = (payload: any) => {
  return {
    type: SIGNALR_MESSAGE_RECEIVED,
    payload,
  };
};

export const updateOrderInfo = (payload: IOrderInfo) => {
  return {
    type: UPDATE_ORDER_INFO,
    payload,
  };
};

export const setOrderInfo = (payload: IOrderInfo) => {
  return {
    type: SET_ORDER_INFO,
    payload,
  };
};

export const startSignalR = (payload: IPayloadWrapper<number>) => {
  return {
    type: SIGNALR_START,
    payload,
  };
};

export const setSignalRConnectionStatus = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_SIGNALR_CONNECTION_STATUS,
    payload,
  };
};

export const fetchFullOrder = (payload: IPayloadWrapper<number>) => {
  return {
    type: FETCH_FULL_ORDER,
    payload,
  };
};

export const setRxMissingAmountDialogSortBoxItem = (
  payload: IPayloadWrapper<ISortBoxItemModel | null>
) => {
  return {
    type: SET_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM,
    payload,
  };
};

export const setRxMissingSortBoxItem = (payload: IPayloadWrapper<ISortBoxItemModel | null>) => {
  return {
    type: SET_MISSING_SORTBOX_ITEM,
    payload,
  };
};

export const setHasShownRxCheckSubsidyIntruction = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_HAS_SHOWN_RX_CHECK_SUBSIDY_INTRUCTION,
    payload,
  };
};

export const setLastCartShelf = (payload: IPayloadWrapper<LimaOperatorTask>) => {
  return {
    type: SET_LAST_CARTSHELF,
    payload,
  };
};

export const setRxInputTask = (payload: IPayloadWrapper<LimaOperatorTask>) => {
  return {
    type: SET_INPUT_TASK,
    payload,
  };
};

export const setRxSingleTransportCart = (payload: IPayloadWrapper<string | null>) => {
  return {
    type: SET_SINGLE_TRANSPORTCART,
    payload,
  };
};

export const setRxNormalTransportCart = (payload: IPayloadWrapper<string | null>) => {
  return {
    type: SET_NORMAL_TRANSPORTCART,
    payload,
  };
};

export const setRxTransportCartRegistrationStarted = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_TRANSPORTCART_REGISTRATION_STARTED,
    payload,
  };
};

export const fetchRxOperatorInstruction = () => {
  return {
    type: FETCH_RX_OPERATOR_INSTRUCTION,
  };
};

export const clearRxOperatorInstruction = () => {
  return {
    type: CLEAR_OPERATOR_INSTRUCTION,
  };
};

export const setRxShowSingleItemList = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_SHOW_SINGLE_ITEM_LIST,
    payload,
  };
};

export const setRxOrderSku = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_ORDER_SKU,
    payload,
  };
};

export const setRxCancelledOrderSku = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_CANCELLED_RX_ORDER_SKU,
    payload,
  };
};

export const setRxWeightError = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_RX_WEIGHT_ERROR,
    payload,
  };
};

export const setRxWarningMessages = (payload: IPayloadWrapper<string[]>) => {
  return {
    type: SET_RX_WARNING_MESSAGES,
    payload,
  };
};

export const setRxActionState = (payload: IPayloadWrapper<ActionStates>) => {
  return {
    type: SET_RX_MODE_ACTION_STATE,
    payload,
  };
};

export const setCancelRxSortBox = () => {
  return {
    type: CANCEL_RX_SORT_BOX,
  };
};

export const setRxSortBoxID = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_SORTBOX_ID,
    payload,
  };
};

export const setRxOrderNumber = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_ORDER_NUMBER,
    payload,
  };
};

export const pollForRxNextSortBox = () => {
  return {
    type: POLL_FOR_RX_NEXT_SORTBOX,
  };
};

export const fetchRxSingleItems = () => {
  return {
    type: FETCH_RX_SINGLE_ITEMS,
  };
};

export const setRxNextCartShelf = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_NEXT_CART_SHELF,
    payload,
  };
};

export const fetchRxBox = (payload: IPayloadWrapper<number>) => {
  return {
    type: FETCH_RX_BOX_MODEL,
    payload,
  };
};

export const pollForRxOrder = () => {
  return {
    type: POLL_FOR_RX_ORDER,
  };
};

export const fetchOrderCommentsForRxOrder = () => {
  return {
    type: FETCH_ORDER_COMMENTS_FOR_RX_ORDER,
  };
};

export const fetchWarningMessagesForRxOrder = () => {
  return {
    type: FETCH_WARNING_MESSAGES_FOR_RX_ORDER,
  };
};

export const setRxBoxModel = (payload: IPayloadWrapper<ISortBoxModel | null>) => {
  return {
    type: SET_RX_BOX_MODEL,
    payload,
  };
};

export const setRxInstruction = (payload: IOperatorInstructionModel) => {
  return {
    type: SET_RX_INSTRUCTION,
    payload,
  };
};

export const setPreviousRxInstruction = (payload: IOperatorInstructionModel) => {
  return {
    type: SET_RX_PREVIOUS_INSTRUCTION,
    payload,
  };
};

export const setRxCrateID = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_CRATE_ID,
    payload,
  };
};

export const setRxFullCartNumber = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_FULL_CART_NUMBER,
    payload,
  };
};

export const setRxAssistingOperator = (payload: IRxAssistantOperator) => {
  return {
    type: SET_RX_ASSISTING_OPERATOR,
    payload,
  };
};

export const setRxAssistingOperatorState = (payload: IPayloadWrapper<IRxAssistantOperator[]>) => {
  return {
    type: SET_RX_ASSISTING_OPERATOR_STATE,
    payload,
  };
};

export const clearRxAssistingOperator = (payload: IPayloadWrapper<number>) => {
  return {
    type: CLEAR_RX_ASSISTING_OPERATOR,
    payload,
  };
};

export const getRxAssistingOperator = () => {
  return {
    type: GET_RX_ASSISTING_OPERATOR,
  };
};

export const setRxSortID = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_SORT_ID,
    payload,
  };
};

export const hideRxComment = (payload: IPayloadWrapper<number>) => {
  return {
    type: HIDE_RX_COMMENT,
    payload,
  };
};

export const setRxOrderComments = (payload: IRxComment[]) => {
  return {
    type: SET_RX_COMMENTS,
    payload,
  };
};

export const clearRxORder = () => {
  return {
    type: CLEAR_RX_ORDER,
  };
};

export const clearRxModeState = () => {
  return {
    type: CLEAR_RX_MODE_STATE,
  };
};

export const setRxVerifyOperator = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_RX_VERIFY_OPERATOR,
    payload,
  };
};

export const setRxPollForOrderIntervalID = (payload: IPayloadWrapper<NodeJS.Timeout>) => {
  return {
    type: SET_RX_POLL_FOR_ORDER_INTERVAL_ID,
    payload,
  };
};

export const setRxPollForNexSortBoxIntervalID = (payload: IPayloadWrapper<NodeJS.Timeout>) => {
  return {
    type: SET_RX_POLL_FOR_NEXT_SORT_BOX_INTERVAL_ID,
    payload,
  };
};

export const setRxSingleItems = (payload: ISingleSortBoxItemModel[]) => {
  return {
    type: SET_RX_SINGLE_ITEMS,
    payload,
  };
};

export const setCancellaionOrFinishModalStatus = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_RX_CANCEL_OR_FINISH_MODAL_STATUS,
    payload,
  };
};

export const setCancellationWithReasonModalStatus = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_RX_CANCELLATION_WITH_REASON_MODAL_STATUS,
    payload,
  };
};

export const setCancellationNonRxOrDoneModalOpen = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_RX_CANCELLATION_NON_RX_OR_DONE_MODAL_STATUS,
    payload,
  };
};

export const setLastActionTimestamp = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_RX_LAST_ACTION_TIMESTAMP,
    payload,
  };
};

export const setWarehouseAlarm = (payload: IPayloadWrapper<number>) => {
  return {
    type: SET_WAREHOUSE_ALARM,
    payload
  }
};
const initialRxBoxState: IRxBoxAppState = {
  orderNumber: -1,
  rxOrderSku: -1,
  rxSortBox: -1,
  sortBoxModel: null,
  currentInstruction: null,
  crateID: -1,
  orderInfo: null,
  orderComments: [],
  rxModeAction: ActionStates.COMPLETE_BOX,
  sortID: -1,
  nextCartShelf: -1,
  fullCartNumber: -1,
  verifyOperator: false,
  pollForOrderIntervalID: (undefined as unknown) as NodeJS.Timeout,
  pollForNexSortBoxIntervalID: (undefined as unknown) as NodeJS.Timeout,
  assistingOperators: [],
  warningMessages: [],
  showSingleItemList: false,
  singleItemList: [],
  previousInstruction: null,
  cancelledRxOrderSku: -1,
  weightError: "",
  singleTransportCart: null,
  normalTransportCart: null,
  inputTask: LimaOperatorTask.undefined,
  transportCartRegistrationStarted: false,
  lastCartShelf: -1,
  hasShownCheckRxSubsidyInstruction: false,
  missingSortBoxItem: null,
  missingAmountDialogSortBoxItem: null,
  signalRConnectionStatus: false,
  stationPaused: false,
  cancelled: false,
  cancellationOrFinishBoxModalOpen: false,
  lastActionTimestamp: -1,
  maxxMode: false,
  loopTeamleader: false,
  cancellationWithReasonModalOpen: false,
  cancellationNonRxOrDoneModalOpen: false,
  teamleaderAvailable: false,
  cancellationReasonMessageShown: false,
  flushQueueModalOpen: false,
  instructionMessage: null,
  skuPutawayBoxID: null,
  skuPutawayBoxItem: null,
  skuPutawayShelfNumber: null,
  skuPutawayErrorMessage: null,
  waitingForEjectBox: false
};

const rxModeReducer = (state = initialRxBoxState, action: any): IRxBoxAppState => {
  switch (action.type) {
    case SKU_PUTAWAY_ERROR_MESSAGE:
      return {...state, skuPutawayErrorMessage: action.payload.value };
    case SET_SKU_PUTAWAY_BIN_SHELFNUMBER: 
      return {...state, skuPutawayShelfNumber: action.payload.value };
    case SET_SKU_PUTAWAY_BOX_ITEM:
      return {...state, skuPutawayBoxItem: action.payload.value };
    case SET_SKU_PUTAWAY_BOXID:
      return {...state, skuPutawayBoxID: action.payload.value };
    case SET_FLUSH_QUEUE_MODAL_STATUS:
        return { ...state, flushQueueModalOpen: action.payload.value };
    case SET_CANCELLATION_REASON_MESSAGE_SHOWN:
      return { ...state, cancellationReasonMessageShown: action.payload.value };
    case SET_TEAMLEADER_AVAILABILITY:
      return { ...state, teamleaderAvailable: action.payload.value };
    case SET_RX_CANCELLATION_WITH_REASON_MODAL_STATUS:
      return { ...state, cancellationWithReasonModalOpen: action.payload.value };
    case SET_RX_CANCELLATION_NON_RX_OR_DONE_MODAL_STATUS:
      return { ...state, cancellationNonRxOrDoneModalOpen: action.payload.value };
    case SET_LOOP_TEAMLEADER:
      return { ...state, loopTeamleader: action.payload.value };
    case SET_MAXX_MODE:
      return { ...state, maxxMode: action.payload.value };
    case SET_BOX_CANCELLED:
      return { ...state, cancelled: action.payload.value };
    case SET_RX_LAST_ACTION_TIMESTAMP:
      return { ...state, lastActionTimestamp: action.payload.value };
    case SET_SIGNALR_CONNECTION_STATUS:
      return { ...state, signalRConnectionStatus: action.payload.value };
    case SET_RX_INSTRUCTION:
      return { ...state, currentInstruction: action.payload };
    case SET_RX_CRATE_ID:
      return { ...state, crateID: action.payload.value };
    case SET_RX_SORT_ID:
      return { ...state, sortID: action.payload.value };
    case SET_RX_COMMENTS:
      return { ...state, orderComments: action.payload };
    case SET_RX_BOX_MODEL:
      return { ...state, sortBoxModel: action.payload.value };
    case HIDE_RX_COMMENT:
      let clickedComment = state.orderComments.filter((x) => x.visible)[action.payload.value];
      clickedComment.visible = false;
      return { ...state, orderComments: state.orderComments };
    case SET_RX_MODE_ACTION_STATE:
      return { ...state, rxModeAction: action.payload.value };
    case CLEAR_RX_MODE_STATE:
      return {
        ...initialRxBoxState,
        crateID: state.crateID,
        signalRConnectionStatus: state.signalRConnectionStatus,
      };
    case SET_RX_ORDER_SKU:
      return { ...state, rxOrderSku: action.payload.value };
    case SET_RX_ORDER_NUMBER:
      return { ...state, orderNumber: action.payload.value };
    case SET_RX_SORTBOX_ID:
      return { ...state, rxSortBox: action.payload.value };
    case SET_RX_FULL_CART_NUMBER:
      return { ...state, fullCartNumber: action.payload.value };
    case SET_RX_NEXT_CART_SHELF:
      return { ...state, nextCartShelf: action.payload.value };
    case SET_RX_VERIFY_OPERATOR:
      return { ...state, verifyOperator: action.payload.value };
    case SET_RX_POLL_FOR_ORDER_INTERVAL_ID:
      return { ...state, pollForOrderIntervalID: action.payload.value };
    case SET_RX_POLL_FOR_NEXT_SORT_BOX_INTERVAL_ID:
      return { ...state, pollForNexSortBoxIntervalID: action.payload.value };
    case SET_RX_ASSISTING_OPERATOR_STATE:
      return { ...state, assistingOperators: action.payload.value };
    case SET_RX_WARNING_MESSAGES:
      return { ...state, warningMessages: action.payload.value };
    case SET_SHOW_SINGLE_ITEM_LIST:
      return { ...state, showSingleItemList: action.payload.value };
    case SET_RX_SINGLE_ITEMS:
      return { ...state, singleItemList: action.payload };
    case SET_RX_PREVIOUS_INSTRUCTION: {
      return { ...state, previousInstruction: action.payload };
    }
    case SET_CANCELLED_RX_ORDER_SKU: {
      return { ...state, cancelledRxOrderSku: action.payload.value };
    }
    case SET_RX_WEIGHT_ERROR: {
      return { ...state, weightError: action.payload.value };
    }
    case SET_INPUT_TASK: {
      return { ...state, inputTask: action.payload.value };
    }
    case SET_NORMAL_TRANSPORTCART: {
      return { ...state, normalTransportCart: action.payload.value };
    }
    case SET_SINGLE_TRANSPORTCART: {
      return { ...state, singleTransportCart: action.payload.value };
    }
    case CLEAR_OPERATOR_INSTRUCTION: {
      return { ...state, currentInstruction: null };
    }
    case SET_TRANSPORTCART_REGISTRATION_STARTED: {
      return { ...state, transportCartRegistrationStarted: action.payload.value };
    }
    case SET_LAST_CARTSHELF: {
      return { ...state, lastCartShelf: action.payload.value };
    }
    case SET_HAS_SHOWN_RX_CHECK_SUBSIDY_INTRUCTION: {
      return { ...state, hasShownCheckRxSubsidyInstruction: action.payload.value };
    }
    case SET_MISSING_SORTBOX_ITEM: {
      return { ...state, missingSortBoxItem: action.payload.value };
    }
    case SET_MISSING_AMOUNT_DIALOG_SORTBOX_ITEM: {
      return { ...state, missingAmountDialogSortBoxItem: action.payload.value };
    }
    case SET_ORDER_INFO: {
      return { ...state, orderInfo: action.payload };
    }
    case SET_STATION_PAUSED: {
      return { ...state, stationPaused: action.payload.value };
    }
    case SET_RX_CANCEL_OR_FINISH_MODAL_STATUS: {
      return { ...state, cancellationOrFinishBoxModalOpen: action.payload.value };
    }
    case UPDATE_ORDER_INFO: {
      const orderInfo: IOrderInfo = action.payload;
      const s = {
        ...state,
        orderInfo: {
          ...(state.orderInfo as IOrderInfo),
          CurrentSortBoxID: orderInfo.CurrentSortBoxID,
          SortBoxes: orderInfo.SortBoxes,
          ReleaseBox: orderInfo.ReleaseBox,
          SkuPutawayRequired: orderInfo.SkuPutawayRequired,
        } as IOrderInfo,
      };
      return s;
    }
    case SET_SORT_BOX_ITEM_QUANTITY: {
      return {
        ...state,
        sortBoxModel: {
          ...(state.sortBoxModel as ISortBoxModel),
          sortBoxItems: state.sortBoxModel?.sortBoxItems.map((item) =>
            item.skuID === action.payload.SkuID && item.boxID === state.orderInfo?.CurrentSortBoxID
              ? {
                  ...item,
                  verifiedQuantity: action.payload.Quantity,
                }
              : item
          ) as ISortBoxItemModel[],
        },
      };
    }
    case WAITING_FOR_EJECT_BOX:{
      return { ...state, waitingForEjectBox: action.payload.value };
    }
    case SET_INSTRUCTION_MESSAGE: {
      return { ...state, instructionMessage: action.payload.value };
    }
    default:
      return state;
  }
};
export default rxModeReducer;
